export default __webpack_public_path__ + "static/media/desk_preland_6.ae278f9c.jpg";